export const FILTER_BUTTONS = {
  SEE_MORE_OR_LESS: 'SeeMoreOrLess',
  SELECT_ALL: 'SelectAll',
  CLEAR_ALL: 'ClearAll',
};
